export default __webpack_public_path__ + "static/media/MONUSCO_DRSG_recieves_briefing_on_attacks.de0a501f.jpg";